export default __webpack_public_path__ + "static/media/userdefault@80.7bfca281.jpg";